import Head from 'next/head'
import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { AnimatePresence, motion } from 'framer-motion'
let styles = {}
import stylesA from '@/styles/Directory.module.css'
import stylesB from '@/styles/index.module.css'
import Header from '@/components/Header'
import SearchComponent from '@/components/ui/search/SearchComponent'
import DirectoryFilters from '@/components/directory/v2/DirectoryFilters'
import EVsContainer from '@/components/directory/EVsContainer'
import EVsModelContainer from '@/components/directory/EVsModelContainer'
import PaginationComponent from '@/components/ui/pagination/PaginationComponent'
import CountComponent from '@/components/ui/pagination/CountComponent'
import MakesComponent from '@/components/makes/MakesComponent'
import ConnectContainer from '@/components/ConnectContainer'
import Link from 'next/link'
import DisplayComponent from '@/components/directory/v2/DisplayComponent'
import EVsResultsManager from '@/components/directory/v2/EVsResultsManager'
import CWGridLoader from '@/components/ui/loaders/CWGridLoader'
import Footer from '@/components/home/v2/Footer'

Object.assign(styles, stylesA, stylesB)

export default function Directory() {
  const router = useRouter()

  const [filters, setFilters] = useState('')
  const [badges, setBadges] = useState([])
  const [loading, setLoading] = useState(true)

  const [model, setModel] = useState(null)

  const updateFilters = (newFilters) => {
    setFilters(newFilters)
  }

  const [searchTerm, setSearchTerm] = useState({ term: '', type: '' })

  useEffect(() => {
    const handleRouteChange = (url) => {
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 0)
    }

    router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router.events])

  const handleSearch = (newSearchTerm) => {
    let newQuery = { ...router.query, page: 1 } // Initialize newQuery with the current query parameters

    if (newSearchTerm.model) {
      setSearchTerm({ term: newSearchTerm.model, type: 'model' })
      setModel(newSearchTerm.model)
      newQuery.model = newSearchTerm.model
      newQuery.make = newSearchTerm.make // Include make in the query when model is selected
      //delete newQuery.make; // remove 'make' query param when model is selected
      setBadges((prevBadges) => [
        ...prevBadges.filter((badge) => badge.filterIndex !== 'model'),
        { filterIndex: 'model', value: newSearchTerm.model },
        { filterIndex: 'make', value: newSearchTerm.make }, // Maintain make as badge
      ])
    } else {
      setSearchTerm({ term: newSearchTerm.make, type: 'make' })
      setModel(null)
      newQuery.make = newSearchTerm.make
      delete newQuery.model // remove 'model' query param when make is selected
      setBadges((prevBadges) => [
        ...prevBadges.filter((badge) => badge.filterIndex !== 'make'),
        { filterIndex: 'make', value: newSearchTerm.make },
      ])
    }
    router.push({
      pathname: '/directory',
      query: newQuery,
    })
  }

  const handlePageChange = (newPage) => {
    setPage(newPage)
    router.push({
      pathname: '/directory',
      query: { ...router.query, page: newPage },
    })
  }

  const handleBadgeRemove = (filterIndex) => {
    setBadges(badges.filter((badge) => badge.filterIndex !== filterIndex))

    switch (filterIndex) {
      case 'make':
        const { make, ...restMake } = router.query
        router.push({
          pathname: '/directory',
          query: { ...restMake, page: 1 },
        })
        break
      case 'model':
        const { model, ...restModel } = router.query
        router.push({
          pathname: '/directory',
          query: { ...restModel, page: 1 },
        })
        break
      default:
        break
    }
  }

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage)
    router.push({
      pathname: '/directory',
      //query: {...router.query, per_page: newItemsPerPage},
      query: { ...router.query, per_page: newItemsPerPage, page: 1 }, // Reset page to 1
    })
  }

  const onMakeSelect = (make) => {
    const { model, ...rest } = router.query // This creates a new object 'rest' that contains all properties of router.query except 'model'
    // Update the URL with the selected make and ensure model is not present
    router.push({
      pathname: '/directory',
      query: { ...rest, make: make, page: 1 },
    })

    // Add the new filter badge
    setBadges((prevBadges) => [...prevBadges, { filterIndex: 'search', value: make }])

    // Set the model state to null since we have a make now
    setModel(null)
  }

  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [total, setTotal] = useState(0)
  const [totalPages, setTotalPages] = useState(itemsPerPage)
  const [page, setPage] = useState(1)

  const [error, setError] = useState(null)

  const [vehicles, setVehicles] = useState([])

  const [results, setResults] = useState([])

  const [displayMode, setDisplayMode] = useState('list')

  useEffect(() => {
    if (!router.isReady) return

    const newPage = router.query.page ? parseInt(router.query.page, 10) : 1
    const newItemsPerPage = router.query.per_page ? parseInt(router.query.per_page, 10) : 10
    const newMake = router.query.make || ''
    const newModel = router.query.model || ''
    const range = router.query.range || ''
    const sorting = router.query.sorting || ''
    const bodyStyle = router.query.body_style || ''
    const seats = router.query.seats || ''
    const price = router.query.price || ''

    setPage(newPage)
    setItemsPerPage(newItemsPerPage)

    setLoading(true)

    let rangeGte, rangeLte
    if (range) {
      ;[rangeGte, rangeLte] = range.split('-').map(Number)
    }

    let priceGte, priceLte
    if (price) {
      ;[priceGte, priceLte] = price.split('-').map(Number)
    }

    const fetchData = async () => {
      let apiUrl = `${process.env.NEXT_PUBLIC_CLEARWATT_BASE_API}/vehicles/models_grouped_by/?page=${newPage}&page_size=${newItemsPerPage}&make__name=${newMake}`

      // Adding optional parameters to the URL
      if (newModel) {
        apiUrl += `&model=${newModel}`
      }
      if (rangeGte !== undefined && rangeLte !== undefined) {
        apiUrl += `&range__gte=${rangeGte}&range__lte=${rangeLte}`
      }
      if (sorting) apiUrl += `&order_by=${sorting}`
      if (bodyStyle) apiUrl += `&body_style__in=${bodyStyle}`
      if (seats) apiUrl += `&seats=${seats}`
      //if (price) apiUrl += `&price=${price}`
      if (priceGte !== undefined && priceLte !== undefined) {
        apiUrl += `&price__gte=${priceGte}&price__lte=${priceLte}`
      }

      try {
        const response = await fetch(apiUrl)
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        const data = await response.json()
        setVehicles(data.results)
        setResults(data.results)
        setTotal(data.count)
        setTotalPages(data.total_pages)
        setPage(data.current_page)
      } catch (error) {
        console.error('There has been a problem with your fetch operation:', error)
        setError(error)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [router.query, router.isReady])

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.2 }}>
      <Head>
        <title>Electric Vehicle Directory - ClearWatt: Explore the Best EVs</title>
        <meta
          name="description"
          content="Discover a comprehensive directory of electric vehicles with ClearWatt. Compare EV models, specifications, battery ranges, and performance to find the perfect match for your needs."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
        <meta name="robots" content="index, follow" />

        <link rel="icon" href="/favicon.png" />
        <link rel="canonical" href="https://clearwatt.co.uk/directory" />

        {/* Open Graph Metadata */}
        <meta property="og:title" content="Electric Vehicle Directory - ClearWatt" />
        <meta
          property="og:description"
          content="Browse ClearWatt's curated directory of electric vehicles. Get insights on EV specifications, battery health, range, and more to make an informed decision."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://clearwatt.co.uk/directory" />
        <meta property="og:image" content="https://clearwatt.co.uk/ev-directory-thumbnail.jpg" />

        {/* Twitter Card Metadata */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Electric Vehicle Directory - ClearWatt" />
        <meta
          name="twitter:description"
          content="Explore ClearWatt's EV directory for detailed insights on electric vehicle models, including specifications and performance metrics."
        />
        <meta name="twitter:image" content="https://clearwatt.co.uk/ev-directory-thumbnail.jpg" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: 'Electric Vehicle Directory',
            url: 'https://clearwatt.co.uk/directory',
            description:
              "ClearWatt's electric vehicle directory provides a detailed comparison of EV models, battery ranges, specifications, and more to help you choose your next electric car.",
            image: 'https://clearwatt.co.uk/ev-directory-thumbnail.jpg',
            publisher: {
              '@type': 'Organization',
              name: 'ClearWatt',
              logo: {
                '@type': 'ImageObject',
                url: 'https://clearwatt.co.uk/logo.png',
              },
            },
          })}
        </script>
      </Head>

      <Header />

      <div className={styles.directory}>
        <div className={styles.directoryContainer}>
          {/*<BreadCrumb location="Directory"/>
          <div className={styles.H1}>Directory</div>*/}
          <SearchComponent onSearch={handleSearch} />
          <DirectoryFilters total={total} searchTerm={searchTerm} onBadgeRemove={handleBadgeRemove} />

          {results.length > 0 && !loading && (
            <DisplayComponent
              onDisplayChange={setDisplayMode}
              results={results}
              currentPage={page}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          )}

          <AnimatePresence mode="wait">
            {!loading && results.length > 0 ? (
              <motion.div key="modelView" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                <EVsResultsManager results={results} loading={loading} displayMode={displayMode} />
              </motion.div>
            ) : !loading && results.length === 0 && !error ? (
              <motion.div
                key="noResults"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className={styles.noResults}
              >
                <span className={styles.iconResults}>🪫</span> No models found...
              </motion.div>
            ) : !loading && error ? (
              <motion.div
                key="error"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className={styles.noResults}
              >
                <span className={styles.iconResults}>⚠️</span> Error...
              </motion.div>
            ) : null}
          </AnimatePresence>

          {/*<AnimatePresence mode="wait">
            {router.query.model ? (
              <motion.div
                key="carView"
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                exit={{opacity: 0}}>
                <EVsContainer cars={vehicles} loading={loading}/>
              </motion.div>
            ) : (
              <motion.div
                key="modelView"
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                exit={{opacity: 0}}>
                <EVsModelContainer make={router.query.make} shouldFetch={!router.query.model}/>

              </motion.div>
            )}
          </AnimatePresence>*/}
          {!loading && results.length > 0 && (
            <div className={styles.bottomControls}>
              {/*  {Math.ceil(total / perPage) > 1 && (
              <> */}
              <PaginationComponent onPageChange={handlePageChange} total={totalPages} page={page} setPage={setPage} />
              <CountComponent onCountChange={handleItemsPerPageChange} initialCount={itemsPerPage} />
              {/*  </>
            )} */}
            </div>
          )}
        </div>
      </div>

      <CWGridLoader loading={loading} />

      <MakesComponent onMakeSelect={onMakeSelect} />
      <Footer />
    </motion.div>
  )
}
